import { render } from "./articleDetails.vue?vue&type=template&id=21246d0f"
import script from "./articleDetails.vue?vue&type=script&lang=js"
export * from "./articleDetails.vue?vue&type=script&lang=js"

import "./articleDetails.vue?vue&type=style&index=0&id=21246d0f&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__